const $ = window.jQuery;

const megamenu = {
    init: () => {
        const $container = $(".mega-menu-container");
        const $mainContainer = $(".top-navigation");
        const $serviceContainer = $(".top-navigation-service");
        const $backbutton = $(".back");
        const $subMenu = $(".sub-menu");
        const $body = $("body");
        const $menu = $("#menu-main");

        $(".sub-menu > li:first-child").each(function() {
            var parent = $(this).parent('ul').parent('.menu-item-has-children');
            var copy = parent.clone();
            copy.addClass("active-menu");
            $(copy).removeClass("menu-item-has-children").find(".sub-menu").remove();
            $(this).before(copy);
        });

        let $currentMenuParent = $(".current_page_item.active-menu");
        if($currentMenuParent.length > 0){
            $currentMenuParent.parent().addClass("is-visible");
            $currentMenuParent.parent().parent().parent().addClass("is-visible is-visible-final");
            if ($currentMenuParent.parent().hasClass('is-visible')) {
                $menu.addClass("is-visible is-visible-final");
                $container.addClass("mega-menu-container--active bordered");
                $serviceContainer.addClass("bordered");
                $backbutton.addClass("visible");
            }
        }

        else{
            let $currentSecondMenuParent = $(".current_page_item").last();
            $currentSecondMenuParent.parent().addClass("is-visible");
            $currentSecondMenuParent.parent().parent().parent().addClass("is-visible is-visible-final");
            if ($currentSecondMenuParent.parent().hasClass('is-visible')) {
                $menu.addClass("is-visible is-visible-final");
                $container.addClass("mega-menu-container--active bordered");
                $serviceContainer.addClass("bordered");
                $backbutton.addClass("visible");


            }

        }

        $('.button_container').on("click", function() {

            $(this).toggleClass('active');
            $body.toggleClass('lock-scroll');
            var self = $(this);
            var attribute = self.attr('id');
            switch (attribute) {
                case "toggle-search-container":
                    $('#overlay-search').removeClass('open');

                    self.attr('id', 'toggle');
                    break;
                case "toggle-countries-container":
                    $('#overlay-countries').removeClass('open');
                    self.attr('id', 'toggle');
                    break;
                case "toggle":
                    $('#overlay').toggleClass('open');
                    $('#page-header').toggleClass('bottomline')
                    $('#page-header').toggleClass('colored');
                    $('.button_container_search').toggleClass('none');
                    $('.button_container_countries').toggleClass('none');
                    $(".button_container_language").toggleClass('none');
                    $(".modal").toggleClass('openmodal');
                    if ($backbutton.hasClass("visible")) {
                        $mainContainer.addClass("bordered");
                    }
                    if ($(".modal").hasClass('openmodal')) {
                        $(".modal").removeClass('openmodal');
                    }

                    break;
                default:
                    self.attr('id', 'toggle');
            }

        });

        const submenuHeight = () => {
            const doc = document.documentElement;
            doc.style.setProperty('--submenu-top', '-' + $mainContainer[0].offsetHeight + 'px');
        }

        const menuHeight = () => {
            const doc = document.documentElement;
            doc.style.setProperty('--menu-height',  $container[0].offsetHeight + 'px');
        }
        window.addEventListener('resize', submenuHeight);
        window.addEventListener('resize', menuHeight);
        submenuHeight();
        menuHeight();

        function handleNavMenuHyerarchy() {

            $('.menu-item-has-children a').on("click", function (e) {

                if (!$(this).attr("href") || $(this).attr("href") === '#') {

                    if ($(this).parents('.top-navigation').length) {
                        $(".top-navigation-service")
                            .find('.sub-menu')
                            .removeClass('is-visible');
                    } else {
                        $(".top-navigation")
                            .find('.sub-menu')
                            .removeClass('is-visible');
                    }

                    $(this)
                        .parent()
                        .parent()
                        .find('.sub-menu')
                        .removeClass('is-visible');

                    $(this)
                        .parent()
                        .children('ul')
                        .toggleClass('is-visible')
                    if(!$(this).children('ul').hasClass('menu-item-has-children')){
                        $(this).parent().parent().toggleClass("is-visible-final");
                    }

                    $container.addClass("mega-menu-container--active");
                    $mainContainer.addClass("bordered");
                    $serviceContainer.addClass("bordered");
                    $backbutton.addClass("visible");

                    e.stopPropagation();
                    e.preventDefault();

                }

            });
        }


            handleNavMenuHyerarchy();

       /* $(".menu-item-has-children").on("click", function() {
            $container.addClass("mega-menu-container--active");
            $mainContainer.addClass("bordered");
            $serviceContainer.addClass("bordered");
            $subMenu.removeClass("is-visible");
            $backbutton.addClass("visible");
            $(this).children(".sub-menu").addClass("is-visible");
        }); */

        $('.menu-item-has-children > a').attr('href', '#');

        // $('.js-smooth-scroll-mobile').click(function(e){
        //     $('.button_container').removeClass('active');
        //     $('#overlay').removeClass('open');
        //     $body.removeClass('lock-scroll');
        // });

        $('.back').on("click", function() {

            $(this).parent().find('.sub-menu.is-visible').last().removeClass("is-visible");
            $( ".is-visible-final" ).last().removeClass("is-visible-final");
            let submenu = document.querySelectorAll(".is-visible-final");
            if(submenu.length === 0){
                $mainContainer.removeClass("bordered");
                $("#menu-main").addClass("is-visible");
                $serviceContainer.removeClass("bordered");
                $(".top-navigation-service > ul").addClass("is-visible");
                $(this).removeClass("visible");
            }

        });

        // close megamenu on menuitem click
        // added this function to manage anchor items click
        $('.menu-item > a').on("click", function() {
            if ($(this).attr('href') !== '#') {
                $('.button_container').removeClass('active');
                $body.removeClass('lock-scroll');
                $('#overlay').removeClass('open');
                $('#page-header').removeClass('bottomline')
                $('#page-header').removeClass('colored');
                $('.button_container_search').removeClass('none');
                $('.button_container_countries').removeClass('none');
                $(".button_container_language").removeClass('none');
                $(".modal").removeClass('openmodal');
            }
        });
    }
};

export default megamenu;
